import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { Box, Typography, Stack, ButtonBase } from '@mui/material';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
import { PartDivider } from './PartDivider';
const SingleDocument = ({
  attachment
}: {
  attachment: PartDisplayDataResponse['documents'][0];
}) => {
  const targetExtension = attachment.target.toLowerCase().split('.').pop();
  const getNameWithExtension = () => {
    // Prevents the extension from being added twice
    if (!targetExtension || attachment.name.toLowerCase().endsWith(targetExtension)) {
      return attachment.name;
    }
    return `${attachment.name}.${targetExtension}`;
  };
  return <ButtonBase href={attachment.target} target="_blank" rel="noreferrer" sx={{
    px: 1.5,
    py: 2.5,
    borderTop: '4px solid',
    borderTopColor: 'secondary.main',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.14)',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 1,
    fontSize: 16,
    fontWeight: 500,
    // forces very long single words to wrap instead of overflow
    overflowWrap: 'anywhere'
  }} data-sentry-element="ButtonBase" data-sentry-component="SingleDocument" data-sentry-source-file="PartRelatedDocuments.tsx">
      <InsertDriveFileOutlinedIcon sx={{
      color: 'secondary.main'
    }} data-sentry-element="InsertDriveFileOutlinedIcon" data-sentry-source-file="PartRelatedDocuments.tsx" />
      {getNameWithExtension()}
    </ButtonBase>;
};
export const PartRelatedDocuments = ({
  documents,
  part
}: Pick<PartDisplayDataResponse, 'documents' | 'part'>) => {
  if (documents.length === 0) {
    return null;
  }
  return <>
      <PartDivider data-sentry-element="PartDivider" data-sentry-source-file="PartRelatedDocuments.tsx" />
      <Box sx={{
      py: 2,
      px: [0, 0, 2]
    }} data-sentry-element="Box" data-sentry-source-file="PartRelatedDocuments.tsx">
        <Typography variant="h4" component="h3" title={`${part.partNumber} Related documents`} sx={{
        mb: 3
      }} data-sentry-element="Typography" data-sentry-source-file="PartRelatedDocuments.tsx">
          {part.partNumber} Related Documents
        </Typography>
        <Stack gap={3} direction="row" flexWrap="wrap" data-sentry-element="Stack" data-sentry-source-file="PartRelatedDocuments.tsx">
          {documents.map(attachment => <SingleDocument key={attachment.id} attachment={attachment} />)}
        </Stack>
      </Box>
    </>;
};